import { render, staticRenderFns } from "./PaymentGroupSettlementForm.vue?vue&type=template&id=0fb28875&scoped=true"
import script from "./PaymentGroupSettlementForm.vue?vue&type=script&lang=js"
export * from "./PaymentGroupSettlementForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentGroupSettlementForm.vue?vue&type=style&index=0&id=0fb28875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb28875",
  null
  
)

export default component.exports